import { Done } from "@mui/icons-material";
import { alpha, Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetFilesByPathsQuery } from "src/api/services/bucketApi";
import { AiInteractionFile } from "src/api/types";
import { theme } from "src/assets/theme";
import FormattedResponse from "src/components/QuestionAnswerBlock/components/FormattedResponse";
import TypingIndicator from "src/components/TypingIndicator";
import FileView from "./components/FileView";
import { useMemo } from "react";
import { isTruthy } from "src/utils/isTruthy";

type Agents = "vida" | "knowledge";

type Props = {
  question: string;
  answer: string;
  agent: Agents;
  files?: AiInteractionFile[];
};

const styles = {
  bgcolor: "grey.100",
  borderRadius: 3,
  minWidth: "10%",
  maxWidth: "70%",
  boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`,
  p: 2,
  width: "fit-content",
};

const HistoricalBlock = ({ question, answer, agent, files = [] }: Props) => {
  const paths = useMemo(() => files.map((f) => f.storage_path), [files]);
  console.log({ paths });
  const { data = [] } = useGetFilesByPathsQuery(
    paths.length > 0
      ? {
          bucket: "ai-interaction-files",
          paths: paths,
        }
      : skipToken,
  );

  const filesWithUrls = useMemo(() => {
    return files
      .map((f) => {
        const match = data.find(
          (d) => d.path === f.storage_path && d.signedUrl,
        );
        if (match == null) return null;

        return {
          ...f,
          signedUrl: match.signedUrl,
        };
      })
      .filter((d) => isTruthy(d));
  }, [data, files]);

  return (
    <Stack width={"100%"} gap={2}>
      <Stack gap={0.5}>
        <Stack
          direction={"row"}
          alignSelf={"end"}
          maxWidth={"70%"}
          spacing={1}
          sx={{ overflowX: "auto", overflowY: "hidden" }}
        >
          {filesWithUrls.length > 0
            ? filesWithUrls.map((file) => (
                <Box alignSelf={"end"} key={file.id}>
                  <FileView file={file} />
                </Box>
              ))
            : null}
        </Stack>
        <Stack
          alignSelf={"end"}
          p={2}
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.05),
            borderRadius: "10px",
            minWidth: 0,
            maxWidth: "60%",
            border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`,
          }}
        >
          {question}
        </Stack>
      </Stack>

      {answer.length === 0 ? null : (
        <FormattedResponse sx={agent === "knowledge" ? styles : null}>
          {answer}
        </FormattedResponse>
      )}
      {agent === "knowledge" && answer ? (
        <Typography variant="subtitle2">Vida - AI Agent</Typography>
      ) : null}
      {answer != null ? (
        agent === "vida" ? (
          <Done color="success" fontSize="large" />
        ) : null
      ) : (
        <TypingIndicator />
      )}
    </Stack>
  );
};

export default HistoricalBlock;
